(function () {
  (function ($) {
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }
    var Pagination = {
      code: "",
      Extend: function (data) {
        data = data || {};
        Pagination.size = data.size || 300;
        Pagination.page = data.page || 1;
        Pagination.step = data.step || 3;
        Pagination.item = data.item || 10;
      },
      Add: function (s, f) {
        for (var i = s; i < f; i++) {
          Pagination.code += '<a data-id="' + i + '">' + i + "</a>";
        }
      },
      Last: function () {
        Pagination.code +=
          '<i>...</i><a data-id="' +
          Pagination.size +
          '">' +
          Pagination.size +
          "</a>";
      },
      First: function () {
        Pagination.code += '<a data-id="1">1</a><i>...</i>';
      },
      Click: function () {
        Pagination.page = +this.innerHTML;
        if (Pagination.page == 1 || Pagination.page == 0) {
          $("#pagination .prev").hide();
        } else {
          $("#pagination .prev").show();
        }
        Pagination.Start();
      },
      Prev: function () {
        Pagination.page--;
        if (Pagination.page == 1 || Pagination.page == 0) {
          $("#pagination .prev").hide();
        } else if (Pagination.page < 1) {
          $("#pagination .prev").show();
          Pagination.page = 1;
        }
        Pagination.Start();
      },
      Next: function () {
        Pagination.page++;
        if (Pagination.page == Pagination.size) {
          $("#pagination .next").hide();
        } else if (Pagination.page > Pagination.size) {
          Pagination.page = Pagination.size;
          $("#pagination .next").show();
        }
        Pagination.Start();
      },
      Bind: function () {
        var a = Pagination.e.getElementsByTagName("a");
        for (var i = 0; i < a.length; i++) {
          if (+a[i].innerHTML === Pagination.page) a[i].className = "current";
          a[i].addEventListener("click", Pagination.Click, true);
        }
      },
      Finish: function () {
        Pagination.e.innerHTML = Pagination.code;
        Pagination.code = "";
        Pagination.Bind();
      },
      Start: function () {
        if (Pagination.page == 1 || Pagination.page == 0) {
          $("#pagination .prev").hide();
        } else {
          $("#pagination .prev").show();
        }
        if (Pagination.page == Pagination.size) {
          $("#pagination .next").hide();
        } else {
          $("#pagination .next").show();
        }
        if (Pagination.size < Pagination.step * 2 + 6) {
          Pagination.Add(1, Pagination.size + 1);
        } else if (Pagination.page < Pagination.step * 2 + 1) {
          Pagination.Add(1, Pagination.step * 2 + 4);
          Pagination.Last();
        } else if (Pagination.page > Pagination.size - Pagination.step * 2) {
          Pagination.First();
          Pagination.Add(
            Pagination.size - Pagination.step * 2 - 2,
            Pagination.size + 1
          );
        } else {
          Pagination.First();
          Pagination.Add(
            Pagination.page - Pagination.step,
            Pagination.page + Pagination.step + 1
          );
          Pagination.Last();
        }
        Pagination.Finish();
      },
      Buttons: function (e) {
        var nav = e.getElementsByTagName("li");
        nav[0].addEventListener("click", Pagination.Prev, false);
        nav[1].addEventListener("click", Pagination.Next, false);
      },
      Create: function (e) {
        var html;
        html = [
          '<li class="prev"><a><img src="/wp-content/themes/veritone-voice/dist/images/prev.svg" alt="previous button"></a></li>',
          "<span></span>",
          '<li class="next"><a><img src="/wp-content/themes/veritone-voice/dist/images/next.svg" alt="next button"></a></li>',
        ];
        e.innerHTML = html.join("");
        Pagination.e = e.getElementsByTagName("span")[0];
        if (Pagination.size <= Pagination.item) {
          $("#pagination .prev").addClass("hide");
          $("#pagination .next").addClass("hide");
        } else {
          $("#pagination .prev").removeClass("hide");
          $("#pagination .next").removeClass("hide");
        }
        Pagination.Buttons(e);
      },
      Init: function (e, data) {
        Pagination.Extend(data);
        Pagination.Create(e);
        Pagination.Start();
      },
    };

    var paginationInit = function (
      result,
      loadmore,
      jsonArray,
      pageSizes,
      size
    ) {
      Pagination.Init(document.getElementById("pagination"), {
        size: Math.ceil(jsonArray.length / loadmore),
        page: 1,
        step: size,
        item: pageSizes,
      });
    };

    // Declaring a object
    function filterRequest(x, y, z, w, r, d, m) {
      this.jsonArray = [];
      this.result = [];
      this.xhttp = new XMLHttpRequest();
      this.clickItems = document.querySelectorAll(y);
      this.url = x;
      this.filterArray1 = [];
      this.filterArray2 = [];
      this.filterArray3 = [];
      this.filterArray4 = [];
      this.filterArray5 = "";
      this.intialstate = 0;
      this.loadmore = z;
      this.initalState = w;
      this.it = z;
      this.lad = z;
      this.lenght = "";
      this.pagSize = r;
      this.size = d;
      this.divSize = 0;
      this.className = m;
      this.init();
    }

    // Intilize all prototypes
    filterRequest.prototype.init = function () {
      if (document.getElementById("post-filter")) {
        this.request();
        this.clicked();
      }
    };
    // Https Request For Map Json
    filterRequest.prototype.request = function () {
      let _self = this;
      this.xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          let item;
          item = JSON.parse(this.responseText);
          item.forEach((v, i) => {
            _self.jsonArray.push(item[i]);
          });
          _self.result = item;
          _self.lenght = Math.ceil(_self.jsonArray / _self.loadmore);
          paginationInit(
            _self.result,
            _self.lad,
            _self.jsonArray,
            _self.pagSize,
            _self.size
          );
          _self.printDiv(_self, _self.result);
          _self.paginationArrow(_self.result);
          $(".dataloader").remove();
          _self.urlUpdate();
          $(".loading").css("display", "none");
        }
      };
      this.xhttp.open("GET", this.url, true);
      this.xhttp.send();
    };

    // Filter item on click
    filterRequest.prototype.clicked = function () {
      var $th = this;
      $("#post-filter .option").on("click", function () {
        let item = $(this).attr("data-val");
        if (item == "") {
          $th.filterArray1 = [];
        } else {
          $th.filterArray1.pop();
          $th.filterArray1.push(item);
        }
        $th.filteringItem("filtering");
      });
      $("#post-filter .input-wrapper input").on("keyup", function () {
        $th.filterArray5 = $(this).val();
        $th.filteringItem("filtering");
      });
    };
    // Filtering the item on click
    filterRequest.prototype.filteringItem = function (filter) {
      let _self = this;
      let sendResultArray = [];
      if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        _self.jsonArray.forEach((v, i) => {
          sendResultArray.push(_self.jsonArray[i]);
        });
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray(_self.filterArray1, _self.result, filter);
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray(_self.filterArray2, _self.result, filter);
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray(_self.filterArray3, _self.result, filter);
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray(_self.filterArray4, _self.result, filter);
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5.length !== ""
      ) {
        sendResultArray = loopArray(_self.filterArray5, _self.result, filter);
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray1,
          _self.filterArray2,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray1,
          _self.filterArray3,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray1,
          _self.filterArray4,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray1,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray2,
          _self.filterArray3,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray2,
          _self.filterArray4,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray2,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray3,
          _self.filterArray4,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray3,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray2(
          _self.filterArray4,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray3,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray4,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray4,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray2,
          _self.filterArray3,
          _self.filterArray4,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray2,
          _self.filterArray3,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length == 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray2,
          _self.filterArray4,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length == 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray3(
          _self.filterArray3,
          _self.filterArray4,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 == ""
      ) {
        sendResultArray = loopArray4(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray3,
          _self.filterArray4,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length == 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray4(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray3,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length == 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray4(
          _self.filterArray2,
          _self.filterArray3,
          _self.filterArray4,
          _self.filterArray5,
          _self.result,
          filter
        );
      } else if (
        _self.filterArray1.length > 0 &&
        _self.filterArray2.length > 0 &&
        _self.filterArray3.length > 0 &&
        _self.filterArray4.length > 0 &&
        _self.filterArray5 !== ""
      ) {
        sendResultArray = loopArray5(
          _self.filterArray1,
          _self.filterArray2,
          _self.filterArray3,
          _self.filterArray4,
          _self.filterArray5,
          _self.result,
          filter
        );
      }
      _self.intialstate = 0;
      _self.loadmore = _self.it;
      _self.initalState = _self.it;
      paginationInit(
        _self.result,
        _self.lad,
        sendResultArray,
        _self.pagSize,
        _self.size
      );
      _self.printDiv(_self, sendResultArray);
      _self.paginationClicked(sendResultArray);
      _self.paginationArrow(sendResultArray);
      if (sendResultArray.length < _self.lad) {
        jQuery("#pagination li").css("display", "none");
      } else {
        jQuery("#pagination li").css("display", "");
      }

      if (Pagination.page == 1 || Pagination.page == 0) {
        $("#pagination .prev").hide();
      } else {
        $("#pagination .prev").show();
      }
      $(".col-three-grid .column-wrapper .col-three .card-intro h4").dotdotdot({
        height: 113,
        fallbackToLetter: true,
        watch: true,
      });
    };

    // Print data by json
    filterRequest.prototype.printDiv = function (_self, data) {
      loop(_self, data);
    };
    // filtering item by clicking on pagination
    filterRequest.prototype.paginationClicked = function (res) {
      let $th = this;
      let paginationItems = document.querySelectorAll("#pagination span a");
      for (let i = 0; i < paginationItems.length; i++) {
        paginationFunc(paginationItems, i, $th, res);
      }
    };
    filterRequest.prototype.paginationArrow = function (result) {
      let $th = this;
      $(document)
        .off("click", "#pagination .next")
        .on("click", "#pagination .next", function (e) {
          console.log(1);
          let text = parseInt($(this).parent().find(".current").text());
          $th.intialstate = (text - 1) * $th.initalState;
          $th.loadmore = $th.initalState * text;
          $th.printDiv($th, result);
          $("html, body")
            .delay(500)
            .animate(
              {
                scrollTop: $(".resource-view").offset().top,
              },
              500
            );
        });
      $(document)
        .off("click", "#pagination .prev")
        .on("click", "#pagination .prev", function (e) {
          console.log(1);
          let text = parseInt($(this).parent().find(".current").text());
          $th.intialstate = (text - 1) * $th.initalState;
          $th.loadmore = $th.initalState * text;
          console.log(text);
          $th.printDiv($th, result);
          $("html, body")
            .delay(500)
            .animate(
              {
                scrollTop: $(".resource-view").offset().top,
              },
              500
            );
        });
    };

    // Loop the html struture
    function loop(_self, data) {
      let idElement = document.getElementById("grid");
      jQuery("#grid > div").not(".grid-sizer").remove();
      if (data) {
        if (data.length > 0) {
          data.slice(_self.intialstate, _self.loadmore).map(function (item) {
            let printItem = "";
            printItem = htmlPrint(item);
            idElement.insertAdjacentHTML("beforeend", printItem);
          });
        } else {
          let printItem = '<div class="no-item"><h4>No Item Found</h4></div>';
          idElement.insertAdjacentHTML("beforeend", printItem);
          $(".dataloader").remove();
        }
        if (data.length > 12) {
          $("#pagination").css("display", "block");
        } else {
          $("#pagination").hide();
        }
      }
      _self.paginationClicked(data);
      // _self.paginationArrow(data);
    }

    // Related with loop function
    function htmlPrint(item) {
      let printItem;
      var target;
      if (item.tag[0] === 'Blog') {
        target = "_self";
      } else {
        target = "_blank";
      }

      if (item.tag[0] === 'Video') {
        if ($(".resource-view").hasClass("resources-filter")) {
          printItem =
            '<div class="col-three"><a class="video-active" data-video="' +
            item.link +
            '">Read More</a><div class="img-wrap"><img src="' +
            item.featuredImage +
            '" alt="blogs"/></div><div class="card-intro"><span>' +
            item.tag[0] +
            "</span><h4>" +
            item.title +
            '</h4><div class="hover-content"><div class="btn-wrap"><a href="' +
            item.link +
            '" target="_blank" rel="noreferrer, noopener" class="link-btn" > ' +
            item.linkText +
            ' <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><defs><clipPath id="vwjm7dk2ua"><path data-name="Rectangle 4165" transform="translate(0 -.198)" style="fill:#fff;stroke:#fff;stroke-width:.5px" d="M0 0h19v19H0z"/></clipPath></defs><g data-name="Group 25073"><g data-name="Group 25072" transform="translate(0 .199)" style="clip-path:url(#vwjm7dk2ua)"><path data-name="Path 26213" d="M14.717 33.041H1.549A1.551 1.551 0 0 1 0 31.492V17.549A1.551 1.551 0 0 1 1.549 16h8.908a.387.387 0 0 1 0 .775H1.549a.775.775 0 0 0-.775.775v13.942a.775.775 0 0 0 .775.775h13.168a1.551 1.551 0 0 0 1.549-1.549v-8.134a.387.387 0 1 1 .775 0v8.133a2.326 2.326 0 0 1-2.324 2.324" transform="translate(.106 -14.345)" style="fill:#fff;stroke:#fff;stroke-width:.5px"/><path data-name="Path 26214" d="M133.809 6.2a.387.387 0 0 1-.387-.387V.775h-5.035a.387.387 0 1 1 0-.775h5.422a.387.387 0 0 1 .387.387v5.422a.387.387 0 0 1-.387.387" transform="translate(-115.501 .106)" style="fill:#fff;stroke:#fff;stroke-width:.5px"/><path data-name="Path 26215" d="M92.387 9.683a.387.387 0 0 1-.274-.661l8.908-8.908a.387.387 0 0 1 .548.548l-8.908 8.907a.386.386 0 0 1-.274.113" transform="translate(-82.986 .105)" style="fill:#fff;stroke:#fff;stroke-width:.5px"/></g></g></svg></span></a></div></div></div></div>';
        }
      } else {
        if ($(".resource-view").hasClass("resources-filter")) {
          printItem =
            '<div class="col-three"><a target="' + target + '" href="' +
            item.link +
            '">Read More</a><div class="img-wrap"><img src="' +
            item.featuredImage +
            '" alt="blogs"/></div><div class="card-intro"><span>' +
            item.tag[0] +
            "</span><h4>" +
            item.title +
            '</h4><div class="hover-content"><div class="btn-wrap"><a href="' +
            item.link +
            '" target="_blank" rel="noreferrer, noopener" class="link-btn" > ' +
            item.linkText +
            ' <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><defs><clipPath id="vwjm7dk2ua"><path data-name="Rectangle 4165" transform="translate(0 -.198)" style="fill:#fff;stroke:#fff;stroke-width:.5px" d="M0 0h19v19H0z"/></clipPath></defs><g data-name="Group 25073"><g data-name="Group 25072" transform="translate(0 .199)" style="clip-path:url(#vwjm7dk2ua)"><path data-name="Path 26213" d="M14.717 33.041H1.549A1.551 1.551 0 0 1 0 31.492V17.549A1.551 1.551 0 0 1 1.549 16h8.908a.387.387 0 0 1 0 .775H1.549a.775.775 0 0 0-.775.775v13.942a.775.775 0 0 0 .775.775h13.168a1.551 1.551 0 0 0 1.549-1.549v-8.134a.387.387 0 1 1 .775 0v8.133a2.326 2.326 0 0 1-2.324 2.324" transform="translate(.106 -14.345)" style="fill:#fff;stroke:#fff;stroke-width:.5px"/><path data-name="Path 26214" d="M133.809 6.2a.387.387 0 0 1-.387-.387V.775h-5.035a.387.387 0 1 1 0-.775h5.422a.387.387 0 0 1 .387.387v5.422a.387.387 0 0 1-.387.387" transform="translate(-115.501 .106)" style="fill:#fff;stroke:#fff;stroke-width:.5px"/><path data-name="Path 26215" d="M92.387 9.683a.387.387 0 0 1-.274-.661l8.908-8.908a.387.387 0 0 1 .548.548l-8.908 8.907a.386.386 0 0 1-.274.113" transform="translate(-82.986 .105)" style="fill:#fff;stroke:#fff;stroke-width:.5px"/></g></g></svg></span></a></div></div></div></div>';
        }
      }
      return printItem;
    }

    // handling click event on pagination
    function paginationFunc(paginationItems, i, $th, res) {
      paginationItems[i].onclick = function (e) {
        $th.intialstate =
          (parseInt(paginationItems[i].getAttribute("data-id")) - 1) *
          $th.initalState;
        $th.loadmore =
          $th.initalState *
          parseInt(paginationItems[i].getAttribute("data-id"));
        $th.printDiv($th, res);
        console.log("paginatiom");
        $("html, body")
          .delay(100)
          .animate(
            {
              scrollTop: $(".resource-view").offset().top,
            },
            500
          );
      };
    }
    filterRequest.prototype.urlUpdate = function () {
      setTimeout(function () {
        var _self = this;
        let url = window.location.href;
        if (window.location.href.indexOf("?") > -1) {
          url = url.split("?");
          let key = url[1];
          key = key.split("=");
          let keyvalue = key[1];
          let item = $("#" + keyvalue);
          item.trigger("click");
        }
      }, 500);
    };

    function loopArray(filter, array, data) {
      let returnArray = [];
      let filtering1 = data;
      if (filter.constructor !== Array) {
        for (let j = 0; j < array.length; j++) {
          var item = filter.toLowerCase();
          var search = "";
          search = array[j].title;

          if (search) {
            if (search.toLowerCase().match(item)) {
              var found = jQuery.inArray(array[j], returnArray);
              if (found < 0) {
                returnArray.push(array[j]);
              }
            }
          }
        }
      } else {
        for (let j = 0; j < array.length; j++) {
          if (array[j][filtering1]) {
            for (let i = 0; i < array[j][filtering1].length; i++) {
              var item = filter;
              if (item == array[j][filtering1][i]) {
                var found = jQuery.inArray(array[j], returnArray);
                if (found < 0) {
                  returnArray.push(array[j]);
                }
              }
            }
          }
        }
      }
      return returnArray;
    }

    function loopArray2(filter, filter1, array, data) {
      let returnArray = [];
      let returnArray1 = [];
      let filtering = data;
      if (filter1.constructor !== Array) {
        for (let j = 0; j < array.length; j++) {
          var item = filter1.toLowerCase();
          var search = "";
          search = array[j].title;

          if (search) {
            if (search.toLowerCase().match(item)) {
              var found = jQuery.inArray(array[j], returnArray1);
              if (found < 0) {
                returnArray1.push(array[j]);
              }
            }
          }
        }
      } else {
        for (let k = 0; k < filter1.length; k++) {
          for (let j = 0; j < array.length; j++) {
            if (array[j][filtering] && !search) {
              for (let i = 0; i < array[j][filtering].length; i++) {
                var item = filter1[k];
                if (item == array[j][filtering][i]) {
                  var found = jQuery.inArray(array[j], returnArray1);
                  if (found < 0) {
                    returnArray1.push(array[j]);
                  }
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter.length; k++) {
        for (let j = 0; j < returnArray1.length; j++) {
          if (returnArray1[j][filtering]) {
            for (let i = 0; i < returnArray1[j][filtering].length; i++) {
              var item = filter[k];
              if (item == returnArray1[j][filtering][i]) {
                var found = jQuery.inArray(returnArray1[j], returnArray);
                if (found < 0) {
                  returnArray.push(returnArray1[j]);
                }
              }
            }
          }
        }
      }
      return returnArray;
    }

    function loopArray3(filter, filter1, filter2, array, data) {
      let returnArray = [];
      let returnArray1 = [];
      let returnArray2 = [];
      let filtering = data;
      if (filter2.constructor !== Array) {
        for (let j = 0; j < array.length; j++) {
          var item = filter2.toLowerCase();
          var search = "";
          search = array[j].title;

          if (search) {
            if (search.toLowerCase().match(item)) {
              var found = jQuery.inArray(array[j], returnArray2);
              if (found < 0) {
                returnArray2.push(array[j]);
              }
            }
          }
        }
      } else {
        for (let k = 0; k < filter2.length; k++) {
          for (let j = 0; j < array.length; j++) {
            if (array[j][filtering]) {
              for (let i = 0; i < array[j][filtering].length; i++) {
                var item = filter2[k];
                if (item == array[j][filtering][i]) {
                  var found = jQuery.inArray(array[j], returnArray2);
                  if (found < 0) {
                    returnArray2.push(array[j]);
                  }
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter1.length; k++) {
        for (let j = 0; j < returnArray2.length; j++) {
          if (returnArray2[j][filtering]) {
            for (let i = 0; i < returnArray2[j][filtering].length; i++) {
              var item = filter1[k];
              if (item == returnArray2[j][filtering][i]) {
                var found = jQuery.inArray(returnArray2[j], returnArray1);
                if (found < 0) {
                  returnArray1.push(returnArray2[j]);
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter.length; k++) {
        for (let j = 0; j < returnArray1.length; j++) {
          if (returnArray1[j][filtering]) {
            for (let i = 0; i < returnArray1[j][filtering].length; i++) {
              var item = filter[k];
              if (item == returnArray1[j][filtering][i]) {
                var found = jQuery.inArray(returnArray1[j], returnArray);
                if (found < 0) {
                  returnArray.push(returnArray1[j]);
                }
              }
            }
          }
        }
      }
      return returnArray;
    }

    function loopArray4(filter, filter1, filter2, filter3, array, data) {
      let returnArray = [];
      let returnArray1 = [];
      let returnArray2 = [];
      let returnArray3 = [];
      let filtering = data;
      if (filter3.constructor !== Array) {
        for (let j = 0; j < array.length; j++) {
          var item = filter3.toLowerCase();
          var search = "";
          search = array[j].title;

          if (search) {
            if (search.toLowerCase().match(item)) {
              var found = jQuery.inArray(array[j], returnArray3);
              if (found < 0) {
                returnArray3.push(array[j]);
              }
            }
          }
        }
      } else {
        for (let k = 0; k < filter3.length; k++) {
          for (let j = 0; j < array.length; j++) {
            if (array[j][filtering]) {
              for (let i = 0; i < array[j][filtering].length; i++) {
                var item = filter3[k];
                if (array[j].title) {
                  if (item == array[j][filtering][i]) {
                    var found = jQuery.inArray(array[j], returnArray3);
                    if (found < 0) {
                      returnArray3.push(array[j]);
                    }
                  }
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter2.length; k++) {
        for (let j = 0; j < returnArray3.length; j++) {
          if (returnArray3[j][filtering]) {
            for (let i = 0; i < returnArray3[j][filtering].length; i++) {
              var item = filter2[k];
              if (item == returnArray3[j][filtering][i]) {
                var found = jQuery.inArray(returnArray3[j], returnArray2);
                if (found < 0) {
                  returnArray2.push(returnArray3[j]);
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter1.length; k++) {
        for (let j = 0; j < returnArray2.length; j++) {
          if (returnArray2[j][filtering]) {
            for (let i = 0; i < returnArray2[j][filtering].length; i++) {
              var item = filter1[k];
              if (item == returnArray2[j][filtering][i]) {
                var found = jQuery.inArray(returnArray2[j], returnArray1);
                if (found < 0) {
                  returnArray1.push(returnArray2[j]);
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter.length; k++) {
        for (let j = 0; j < returnArray1.length; j++) {
          if (returnArray1[j][filtering]) {
            for (let i = 0; i < returnArray1[j][filtering].length; i++) {
              var item = filter[k];
              if (item == returnArray1[j][filtering][i]) {
                var found = jQuery.inArray(returnArray1[j], returnArray);
                if (found < 0) {
                  returnArray.push(returnArray1[j]);
                }
              }
            }
          }
        }
      }
      return returnArray;
    }

    function loopArray5(
      filter,
      filter1,
      filter2,
      filter3,
      filter4,
      array,
      data
    ) {
      let returnArray = [];
      let returnArray1 = [];
      let returnArray2 = [];
      let returnArray3 = [];
      let returnArray4 = [];
      let filtering = data;
      for (let j = 0; j < array.length; j++) {
        var item = filter5.toLowerCase();
        var search = "";
        search = array[j].title;

        if (search) {
          if (search.toLowerCase().match(item)) {
            var found = jQuery.inArray(array[j], returnArray4);
            if (found < 0) {
              returnArray4.push(array[j]);
            }
          }
        }
      }
      for (let k = 0; k < filter3.length; k++) {
        for (let j = 0; j < returnArray4.length; j++) {
          if (returnArray4[j][filtering]) {
            for (let i = 0; i < returnArray4[j][filtering].length; i++) {
              var item = filter3[k];
              if (item == returnArray4[j][filtering][i]) {
                var found = jQuery.inArray(returnArray4[j], returnArray3);
                if (found < 0) {
                  returnArray3.push(returnArray4[j]);
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter2.length; k++) {
        for (let j = 0; j < returnArray3.length; j++) {
          if (returnArray3[j][filtering]) {
            for (let i = 0; i < returnArray3[j][filtering].length; i++) {
              var item = filter2[k];
              if (item == returnArray3[j][filtering][i]) {
                var found = jQuery.inArray(returnArray3[j], returnArray2);
                if (found < 0) {
                  returnArray2.push(returnArray3[j]);
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter1.length; k++) {
        for (let j = 0; j < returnArray2.length; j++) {
          if (returnArray2[j][filtering]) {
            for (let i = 0; i < returnArray2[j][filtering].length; i++) {
              var item = filter1[k];
              if (item == returnArray2[j][filtering][i]) {
                var found = jQuery.inArray(returnArray2[j], returnArray1);
                if (found < 0) {
                  returnArray1.push(returnArray2[j]);
                }
              }
            }
          }
        }
      }
      for (let k = 0; k < filter.length; k++) {
        for (let j = 0; j < returnArray1.length; j++) {
          if (returnArray1[j][filtering]) {
            for (let i = 0; i < returnArray1[j][filtering].length; i++) {
              var item = filter[k];
              if (item == returnArray1[j][filtering][i]) {
                var found = jQuery.inArray(returnArray1[j], returnArray);
                if (found < 0) {
                  returnArray.push(returnArray1[j]);
                }
              }
            }
          }
        }
      }
      return returnArray;
    }

    // intilize object by set of diffrent parameter's:
    // 1. json path
    // 2. url of filtered item
    // 3. item to show on load
    // 4. inital state
    // 5. paginaton size

    if ($(".resource-view").hasClass("resources-filter")) {
      new filterRequest(
        "/wp-content/themes/veritone-voice/json/resources.json",
        ".resource-view .top-link",
        12,
        12,
        3,
        1,
        ".filter-grid"
      );
    }
    $(window).on("load", function () {
      setTimeout(function () {
        let pathname = window.location.href;
        let spliturl = pathname.split("?");
        let id = spliturl[1];
        $(".resources-filter .list li").each(function () {
          let attr = $(this).attr("data-val");
          if (attr === id) {
            $(this).trigger("click");
            $(this).parent().css("display", "none");
            $("html, body")
              .delay(500)
              .animate(
                {
                  scrollTop:
                    $("#post-filter").offset().top - $(".header").height(),
                },
                500
              );
          }
        });
      }, 1000);
    });
  })(jQuery);
})();
